import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routes from '@/config/routes';
import { SpeedTestSessionKey } from '@/constants';

const SpeedTest = (): React.ReactElement | null => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const history = useHistory();

  useEffect(() => {
    if (Boolean(isLoggedIn)) {
      history.push(routes.sp.scheduling.user.profile.internetTest);
    } else {
      localStorage.setItem(SpeedTestSessionKey, 'true');
      history.push(routes.root);
    }
  }, [isLoggedIn, history]);

  return null;
};

export default SpeedTest;
